import { Guest } from '@/types';

export const computeSeatsUsed = (guests: Guest[]): number =>
  guests.reduce((acc, g) => acc + 1 + (g.numero_acompanantes ?? 0), 0);
